import { Route, Routes } from 'react-router-dom';
import ListUserRole from './pages/ListUserRole';
import CreateUserRole from './pages/CreateUserRole';
import EditUserRole from './pages/EditUserRole';

const UserRole = () => {
  return (
    <Routes>
      <Route path="" element={<ListUserRole />} />
      <Route path="create" element={<CreateUserRole />} />
      <Route path="edit/:id" element={<EditUserRole />} />
    </Routes>
  );
};

export default UserRole;
